import { createBrowserRouter, Outlet } from "react-router-dom";
import { authRouter } from "./auth.router";
import { adminRouter } from "./admin.router";
import { brandRouter } from "./brand.router";
import { LayoutCommonScreen } from "../screens/layout.common.screen";
import {
	PrivateAdminRoute,
	PrivateEphemeralRoute,
} from "../components/private-route.components";
import { AdminLayoutAdminScreen } from "../screens/admin/admin-layout.admin.screen";
import { BrandLayoutBrandScreen } from "../screens/brand/brand-layout.brand.screen";
import { NotFound } from "../components/not-found.components";
import { AuthLayoutCommonScreen } from "../screens/common/auth/auth-layout.common.screen";
import { ShareMetricsCommonScreen } from "../screens/common/share-metrics/share-metrics.common.screen";
import { CampaignBriefCommonScreen } from "../screens/common/campaign-brief/campaign-brief.common.screen";
import { baseBrandsRouter } from "../brands/router/base.router";

export const router = createBrowserRouter([
	{
		path: "/",
		element: <LayoutCommonScreen />,
	},
	{
		path: "/auth",
		children: authRouter,
		element: <AuthLayoutCommonScreen />,
	},
	{
		path: "/admin",
		element: (
			<PrivateAdminRoute>
				<AdminLayoutAdminScreen />
			</PrivateAdminRoute>
		),
		children: adminRouter,
	},
	{
		path: "/brands",
		children: baseBrandsRouter,
	},
	{
		path: "/ephemeral",
		element: (
			<PrivateEphemeralRoute>
				<LayoutCommonScreen />
			</PrivateEphemeralRoute>
		),
	},
	{
		path: "/ephemeral/brand-dash",
		element: (
			<PrivateEphemeralRoute>
				<BrandLayoutBrandScreen />
			</PrivateEphemeralRoute>
		),
		children: brandRouter,
	},
	{
		path: "utils/campaign-metrics/print",
		element: <ShareMetricsCommonScreen />,
	},
	{
		path: "campaign-brief",
		element: <Outlet />,
		children: [
			{
				path: ":campaignId",
				element: <CampaignBriefCommonScreen />,
			},
		],
	},

	{
		path: "*",
		element: <NotFound />,
	},
]);
